/**
 * Photo-meta freshness + ownership for general profile saves — its own tiny
 * module so the storage layer (on the app's first-paint path) can apply it
 * without pulling in the photo maths. Pure.
 */

/**
 * Which meta a GENERAL profile save keeps. The capture path owns the meta
 * (saveOwnPhotoMeta is its only writer); a screen saving an older copy of the
 * profile must never write that copy's meta over a newer one. Device pass
 * 2026-10-01: Profile's form state still held the previous photo's meta, saved
 * it with the new photo, and the new photo read as "no meta" → un-framed.
 *
 * The incoming meta wins only when it belongs to the photo being saved and
 * the stored one doesn't (e.g. a recovery onto a fresh device); otherwise the
 * stored meta stands.
 *
 * @param {Object|undefined} incoming - the meta on the object being saved
 * @param {Object|undefined} stored - the meta already stored
 * @param {string|undefined} photoUrl - the photo being saved
 * @returns {Object|undefined}
 */
export const keepPhotoMeta = (incoming, stored, photoUrl) => {
  if (!stored) return incoming;
  if (!incoming) return stored;
  return isFreshMeta(incoming, photoUrl) && !isFreshMeta(stored, photoUrl) ? incoming : stored;
};

/**
 * THE freshness rule: a meta belongs to the photo it was computed for. Meta
 * whose `src` isn't the current photo is stale and reads as absent, so no
 * photo-change path can show someone else's crop.
 *
 * @param {Object|null|undefined} meta
 * @param {string|null|undefined} photoUrl
 * @returns {boolean}
 */
export const isFreshMeta = (meta, photoUrl) => !!meta && !!photoUrl && meta.src === photoUrl;
